// This example uses `@web3forms/react` plugin and tailwindcss for css styling

import { useState } from 'react';
import { useForm } from 'react-hook-form';
import useWeb3Forms from '@web3forms/react';
//
// import Button from '../elements/Button';
import Logo from '../layout/partials/Logo';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
// import Input from '../elements/Input';

import styled from 'styled-components';

const Button = styled.button`
  background: #2e2d2d;
  border-radius: 3px;
  border: 2px white;
  color: white;
  margin: 0 1em;
  padding: 0.25em 1.35em;
  &:hover,
  &:focus {
    color: solid white;
  }
  &:active {
    color: solid black;
  }
`;

//
// const InputLabel = styled.label`
//   color: #8d8d8d;
//   position: absolute;
//   top: 27px;
//   left: 55px;
//   background: #ffffff;
//   transition: 300ms;
//   transform: translate(-50%, -50%);
// `;

const InputField = styled.input`
  outline: none;
  padding: 16px 22px;
  border: 1px solid #dadce0;
  font-size: 19px;
  border-radius: 5px;
  text-align: center;
  align-items: center;
  transition: 300ms;
  @media only screen and (max-width: 708px) {
    /* Adjust styles for screens smaller than 768px */
    padding: 12px 16px;

    font-size: 14px;
  }

  @media only screen and (max-width: 460px) {
    /* Adjust styles for screens smaller than 480px */
    padding: 8px 12px;
    font-size: 12px;
  }
`;

//
const propTypes = {
  ...SectionProps.types,
  split: PropTypes.bool,
};

const defaultProps = {
  ...SectionProps.defaults,
  split: false,
};

//

const Cta2 = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  split,
  ...props
}) => {
  const outerClasses = classNames(
    'cta section center-content-mobile reveal-from-bottom',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'cta-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider',
    split && 'cta-split'
  );
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitSuccessful, isSubmiting },
  } = useForm({
    mode: 'onTouched',
  });
  const [isSuccess, setIsSuccess] = useState(false);
  const [message, setMessage] = useState(false);
  const { isLoading, setIsLoading } = useState(false);

  // Please update the Access Key in the .env
  const apiKey = process.env.REACT_APP_PUBLIC_ACCESS_KEY || '-acessdenied';

  const { submit: onSubmit } = useWeb3Forms({
    access_key: apiKey,
    settings: {
      from_name: 'Inmetal',
      subject: 'www',
    },
    onSuccess: (msg, data) => {
      setIsSuccess(true);
      setMessage(msg);
      reset();
    },
    onError: (msg, data) => {
      setIsSuccess(false);
      setMessage(msg);
    },
    onIsSubmiting: (msg, data) => {
      setIsLoading(true);
      setMessage(msg);
    },
  });

  // const handleSubmitas = async (event) => {
  //   event.preventDefault();
  //   setIsLoading(true);
  //   try {
  //     const response = await fetch('/kontaktai', {
  //       method: 'POST',
  //       body: new FormData(event.target),
  //     });
  //     const json = await response.json();
  //     setIsSuccess(json.success);
  //     isSuccess(true);
  //   } catch (error) {
  //     console.error('Nepavyko išsiųsti: ', error);
  //   }
  //   setIsLoading(false);
  // };

  return (
    <>
      <section {...props} className={outerClasses}>
        <div className="container">
          <div className={innerClasses}>
            <div className="cta-slogan">
              <div
                style={{
                  display: 'flex',
                  textAlign: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',

                  margin: '0 auto',

                  borderRadius: '5px',
                }}
              >
                {' '}
                <Logo
                  style={{
                    margin: '10px auto',
                    padding: '5px',
                  }}
                />{' '}
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  style={{
                    textAlign: 'center',
                    alignItems: 'center',

                    display: 'flex',
                    flexDirection: 'column',
                    // padding: '0 250px',

                    gap: '12px ',

                    // border: '2px solid white',
                  }}
                >
                  <InputField
                    id="email"
                    data-reveal-delay="50"
                    //   className="reveal-from-bottom"
                    type="email"
                    placeholder="Elektroninis paštas"
                    style={{ border: ' 1px solid grey' }}
                    autoComplete="false"
                    className={`cta-action ${
                      errors.email
                        ? 'border-red-600 focus:border-red-600 ring-red-100 dark:ring-0'
                        : 'border-gray-300 focus:border-gray-600 ring-gray-100 dark:border-gray-600 dark:focus:border-white dark:ring-0'
                    }`}
                    {...register('email', {
                      required: 'Įveskite Savo el. paštą!',
                      pattern: {
                        value: /^\S+@\S+$/i,
                        message: 'Įveskite galiojantį el. paštą!',
                      },
                    })}
                  ></InputField>{' '}
                  {errors.email && (
                    <div className="mt-1 text-red-600">
                      <small>{errors.email.message}</small>
                    </div>
                  )}
                  <InputField
                    id="name"
                    data-reveal-delay="50"
                    label="Jūsų vardas:"
                    placeholder="Vardas"
                    style={{ border: ' 1px solid grey' }}
                    // className="reveal-from-bottom"
                    autoComplete="false"
                    className={`placeholder:text-gray-800 dark:text-white rounded-md outline-none dark:placeholder:text-gray-200 dark:bg-gray-900   focus:ring-4  ${
                      errors.name
                        ? 'border-red-600 focus:border-red-600 ring-red-100 dark:ring-0'
                        : 'border-gray-300 focus:border-gray-600 ring-gray-100 dark:border-gray-600 dark:focus:border-white dark:ring-0'
                    }`}
                    {...register('name', {
                      required: 'Reikalingas vardas!',
                      maxLength: 80,
                      // className: 'form-label',
                    })}
                  />
                  {errors.name && (
                    <div className="mt-1 text-red-600">
                      <small>{errors.name.message}</small>
                    </div>
                  )}
                  <InputField
                    id="message"
                    data-reveal-delay="50"
                    //   className="reveal-from-bottom"
                    label="Jūsų žinutė:"
                    placeholder="
                  Žinutė"
                    style={{ border: ' 1px solid grey' }}
                    className={` ${
                      errors.message
                        ? 'border-red-600 focus:border-red-600 ring-red-100 dark:ring-0'
                        : 'border-gray-300 focus:border-gray-600 ring-gray-100 dark:border-gray-600 dark:focus:border-white dark:ring-0'
                    }`}
                    {...register('message', {
                      required: 'Įveskite žinutę!',
                    })}
                  ></InputField>{' '}
                  {errors.message && (
                    <div className="mt-1 text-red-600">
                      {' '}
                      <small>{errors.message.message}</small>
                    </div>
                  )}
                  <div className="reveal-from-bottom " data-reveal-delay="50">
                    <Button
                      id="siusti_conversion"
                      type="submit"
                      style={{
                        margin: ' 29px',
                        border: '1px solid white',
                      }}
                    >
                      SIŲSTI
                    </Button>
                  </div>
                  {isSubmiting && isLoading && (
                    <div>
                      {'Loading...'} <div>info@inmetal.eu</div>
                    </div>
                  )}
                  {isSubmitSuccessful && isSuccess && (
                    <div>
                      {'Sėkmingai išsiųsta!'} <div>info@inmetal.eu</div>
                    </div>
                  )}
                  {isSubmitSuccessful && !isSuccess && (
                    <div>
                      {'Nepavyko išsiųsti.'} <div>info@inmetal.eu</div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

Cta2.propTypes = propTypes;
Cta2.defaultProps = defaultProps;

export default Cta2;
